module.exports = __webpack_public_path__ + "media/images/check-207c9cbc9e0a7463fc0afd7d3121a514.svg";